import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/app/components/ui/dialog'
import { InventoryItem } from '@/app/services/inventory.service'

interface DetailModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  selectedItem: InventoryItem | null
}

export function DetailModal({
  open,
  onOpenChange,
  selectedItem,
}: DetailModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Detalles del Producto</DialogTitle>
          <DialogDescription className="sr-only">
            Información completa del producto incluyendo stock, lote y
            caducidad
          </DialogDescription>
        </DialogHeader>
        {selectedItem && (
          <div className="space-y-4">
            <div className="rounded-lg bg-slate-50 p-4">
              <h3 className="mb-3 font-semibold text-slate-900">
                {selectedItem.name}
              </h3>
              <div className="grid grid-cols-2 gap-3 text-sm">
                <div>
                  <span className="text-slate-600">Categoría:</span>
                  <p className="font-medium text-slate-900">
                    {selectedItem.category}
                  </p>
                </div>
                <div>
                  <span className="text-slate-600">Sucursal:</span>
                  <p className="font-medium text-slate-900">
                    {selectedItem.branch}
                  </p>
                </div>
                <div>
                  <span className="text-slate-600">Stock actual:</span>
                  <p className="font-medium text-slate-900">
                    {selectedItem.stock} unidades
                  </p>
                </div>
                <div>
                  <span className="text-slate-600">Stock mínimo:</span>
                  <p className="font-medium text-slate-900">
                    {selectedItem.minStock} unidades
                  </p>
                </div>
                <div>
                  <span className="text-slate-600">Lote:</span>
                  <p className="font-medium text-slate-900">
                    {selectedItem.lot}
                  </p>
                </div>
                <div>
                  <span className="text-slate-600">Caducidad:</span>
                  <p className="font-medium text-slate-900">
                    {selectedItem.expiry}
                  </p>
                </div>
                <div>
                  <span className="text-slate-600">Precio venta:</span>
                  <p className="font-medium text-slate-900">
                    ${selectedItem.price.toFixed(2)}
                  </p>
                </div>
                <div>
                  <span className="text-slate-600">Costo:</span>
                  <p className="font-medium text-slate-900">
                    ${selectedItem.cost.toFixed(2)}
                  </p>
                </div>
                <div>
                  <span className="text-slate-600">Proveedor:</span>
                  <p className="font-medium text-slate-900">
                    {selectedItem.supplier}
                  </p>
                </div>
                <div>
                  <span className="text-slate-600">Último movimiento:</span>
                  <p className="font-medium text-slate-900">
                    {selectedItem.lastMovement}
                  </p>
                </div>
              </div>
            </div>

            <div className="rounded-lg border border-blue-200 bg-blue-50 p-3">
              <p className="text-sm text-blue-900">
                <strong>Margen de utilidad:</strong>{' '}
                {(
                  ((selectedItem.price - selectedItem.cost) /
                    selectedItem.cost) *
                  100
                ).toFixed(1)}
                %
              </p>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
